import { Container, Title, Value, BoldValue } from './ConfirmationInformationRow.styles';

const ConfirmationInformationRow = ({
    title,
    value,
    boldValue
}: {
    title: string
    value: string
    boldValue?: boolean
}) => {
    return (
        <Container>
            <Title>{title}</Title>
            {boldValue ? (
                <BoldValue>{value}</BoldValue>
            ) : (
                <Value>{value}</Value>
            )}
        </Container>
    )
}

export default ConfirmationInformationRow
